;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="8dae77ca-dc6f-45a7-8ff7-2707f9ed274e",e._sentryDebugIdIdentifier="sentry-dbid-8dae77ca-dc6f-45a7-8ff7-2707f9ed274e")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(74083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleChunkLoadError; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_native_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44482);
/* harmony import */ var _core_native_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26796);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function handleChunkLoadError(error) {
    return _handleChunkLoadError.apply(this, arguments);
}
function _handleChunkLoadError() {
    _handleChunkLoadError = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
        var fileChunkName, fileChunkErrors;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(error.name !== "ChunkLoadError")) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    fileChunkName = getFileChunk(error.message);
                    if (fileChunkName) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 5:
                    _ctx.next = 7;
                    return (0,_core_native_storage__WEBPACK_IMPORTED_MODULE_1__/* .getChunkFileErrors */ .Ls)();
                case 7:
                    fileChunkErrors = _ctx.sent;
                    if (!(fileChunkErrors.findIndex(function(o) {
                        return o === fileChunkName;
                    }) >= 0)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 10:
                    if (!((0,_core_native_app__WEBPACK_IMPORTED_MODULE_2__/* .getPlatform */ .Xf)() === "web")) {
                        _ctx.next = 15;
                        break;
                    }
                    _ctx.next = 13;
                    return (0,_core_native_storage__WEBPACK_IMPORTED_MODULE_1__/* .setChunkFileErrors */ .$_)(_toConsumableArray(fileChunkErrors).concat([
                        fileChunkName
                    ]));
                case 13:
                    window.location.reload();
                    return _ctx.abrupt("return");
                case 15:
                    return _ctx.abrupt("return");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleChunkLoadError.apply(this, arguments);
}
function getFileChunk(message) {
    var matches = message.match(/(\d*.[\\d\w]*.js)/);
    var ref;
    return (ref = matches === null || matches === void 0 ? void 0 : matches[0]) !== null && ref !== void 0 ? ref : "";
}


/***/ }),

/***/ 74083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ App; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_errorHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52525);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




/**
 * Application Start Module
 */ function App() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AppRouter, {});
};
var AppRouter = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    /**
     * @caveat 型変換エラー解消のために一旦変数に格納. バグと思われる
     */ var promise = Promise.all(/* import() */[__webpack_require__.e(8934), __webpack_require__.e(4688), __webpack_require__.e(9097), __webpack_require__.e(4978), __webpack_require__.e(2562)]).then(__webpack_require__.bind(__webpack_require__, 43444)).then(function(md) {
        return md.AppRouter;
    }).catch(function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_3__/* .handleChunkLoadError */ .Z)(error);
                    case 2:
                        return _ctx.abrupt("return", function() {
                            return null;
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43444)
            ];
        }
    },
    ssr: false
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5237,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);